import * as reportsService from '../core/api';
import * as actions from './constants';
import { getTimelineViewItems } from '../core/lms';
import { getConfigObject } from '../util/config';

export const removeWidgetFromDashboard = (
  courseId,
  dashboardWidgetId
) => async (dispatch) => {
  dispatch({
    type: actions.DELETE_DASHBOARD_WIDGET,
    payload: { dashboardWidgetId },
  });
  const results = await reportsService.removeWidgetFromDashboard(
    courseId,
    dashboardWidgetId
  );
  return results;
};

export const addWidgetToDashboard = (
  courseId,
  dashboardId,
  widgetId,
  coordinates
) => async (dispatch) => {
  const widget = await reportsService.addWidgetToDashboard(
    courseId,
    dashboardId,
    widgetId,
    coordinates
  );
  if (widget && !widget.error) {
    dispatch({
      type: actions.ADD_WIDGET_TO_DASHBOARD,
      payload: { widget },
    });
  }
  return widget;
};

export const getDashboardsWidgets = (courseId) => async (dispatch) => {
  const CONFIG = getConfigObject();
  dispatch({ type: actions.GET_DASHBOARD_REQUEST });
  const dashboard = await reportsService.getDashboardsWidgets(courseId);
  const assignmentsResult = await getTimelineViewItems(courseId, {
    assigned: true,
    sort: 'asc',
    pageSize: CONFIG.DASHBOARDS_ASSIGNMENT_PAGE_SIZE,
    page: 0,
  });
  const assignments = assignmentsResult.items.map((a) => ({
    value: a.id,
    label: a.name,
    assignment_due_at: a.dueDate,
    tool: a.tool,
    activityId: a.activityId,
  }));
  if (dashboard && !dashboard.error) {
    dispatch({
      type: actions.GET_DASHBOARD_RESPONSE,
      payload: { dashboard, assignments },
    });
  }
};

export const updateWidgets = (courseId, widgets) => async (dispatch) => {
  const results = await reportsService.updateWidgets(courseId, widgets);
  if (results && !results.error) {
    dispatch({
      type: actions.UPDATE_WIDGETS,
      payload: widgets,
    });
  }
  return results;
};

export const toggleInsightDetailsModal = (widgetId) => (dispatch) => {
  dispatch({ type: actions.TOGGLE_WIDGET_DETAIL_MODAL, payload: { widgetId } });
};

export const clearInsightModals = () => (dispatch) => {
  dispatch({ type: actions.CLEAR_INSIGHT_MODALS });
};

export const getSRLSurveyResultsByCard = (
  courseId,
  assignmentId,
  cardId
) => async (dispatch) => {
  dispatch({ type: actions.GET_SRL_RESULT_CARD_REQUEST });
  const srlSurveyResultsByCardData = await reportsService.getSRLSurveyResultsByCard(
    courseId,
    assignmentId,
    cardId
  );
  if (srlSurveyResultsByCardData && !srlSurveyResultsByCardData.error) {
    dispatch({
      type: actions.GET_SRL_RESULT_CARD_RESPONSE,
      payload: { assignmentId, cardId, srlSurveyResultsByCardData },
    });
  }
  return srlSurveyResultsByCardData;
};

export const getSRLSurveyResults = (courseId, assignmentId) => async (
  dispatch
) => {
  dispatch({ type: actions.GET_SRL_RESULTS_REQUEST });
  const srlSurveyResults = await reportsService.getSRLSurveyResults(
    courseId,
    assignmentId
  );
  if (srlSurveyResults && !srlSurveyResults.error) {
    dispatch({
      type: actions.GET_SRL_RESULTS_RESPONSE,
      payload: { assignmentId, srlSurveyResults },
    });
  }
};

export const getSRLSurveys = (courseId) => async (dispatch) => {
  dispatch({ type: actions.GET_SRL_REQUEST });
  const srlSurveyList = await reportsService.getSRLSurveys(courseId);
  if (srlSurveyList && !srlSurveyList.error) {
    dispatch({
      type: actions.GET_SRL_RESPONSE,
      payload: { srlSurveyList },
    });

    // Start fetching cards for the first survey
    if (srlSurveyList.length > 0) {
      getSRLSurveyResults(courseId, srlSurveyList[0].id)(dispatch);
    }
  }
};

export const containerWidthChange = (width) => (dispatch) => {
  dispatch({ type: actions.CONTAINER_WIDTH_CHANGE, payload: width });
};

export const getAssignments = (courseId) => async (dispatch) => {
  const CONFIG = getConfigObject();
  const result = await getTimelineViewItems(courseId, {
    assigned: true,
    sort: 'asc',
    pageSize: CONFIG.DASHBOARDS_ASSIGNMENT_PAGE_SIZE,
    page: 0,
  });
  const assignments = result.items.map((a) => ({
    value: a.id,
    label: a.name,
    assignment_due_at: a.dueDate,
  }));
  dispatch({
    type: actions.GET_ASSIGNMENTS,
    payload: assignments,
  });
};

export const getAssignmentsV2 = (courseId) => async (dispatch) => {
  const CONFIG = getConfigObject();
  const result = await getTimelineViewItems(courseId, {
    assigned: true,
    sort: 'asc',
    pageSize: CONFIG.DASHBOARDS_ASSIGNMENT_PAGE_SIZE,
    page: 0,
  });
  dispatch({
    type: actions.GET_ASSIGNMENTS,
    payload: result.items,
  });
};

export const setSelectedAssignment = (assignment) => (dispatch) =>
  dispatch({
    type: actions.SET_INSIGHTS_SELECTED_ASSIGNMENT,
    payload: assignment,
  });
